import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import {pickImageStyle} from "@/utils/transforms";
import ShowMoreText from "react-show-more-text";
import Image from "next/image";

const useStyles = makeStyles((theme) => ({
    imgStyles: {
      width: '100%',
      minHeight: 300,
      objectFit: 'cover',
      objectPosition: 'top',
      [theme.breakpoints.down('lg')]: {
        objectFit: 'contain',
      },
    },
    titleStyles: {
      fontSize: 36,
      fontWeight: 700,
      marginBottom: 10,
      color: '#000'
    },
    subtitleStyles: {
      fontWeight: 400,
      color: '#000'
    },
    linkStyles: {
      fontWeight: 300,
      fontSize: 24,
      color: '#1477f8',
    },
    teamHeader: {
      "& svg": {
        height: 25,
        marginRight: 5,
      },
    },
    bodyStyles: {
      fontSize: 18,
      fontWeight: 400,
      '& .expandAnchor': {
        // textDecoration: 'none',
        color: theme.palette.primary.main,
      },
      // '& .content-css': {
      //   marginTop: '1rem',
      // },
      // '& .expand-css': {
      //   display: 'flex',
      //   alignItems: 'center',
      //   fontSize: 16
      // },
      '& p': {
        fontSize: 18
      },
      '& span': {
        fontSize: 18
      },
    },
  }),
);

export default function TeamMemberTeaser(props) {
  let {block, node} = props;
  node = (!node && block) ? block : node;

  let {
    info,
    contact,
    imgAlt,
    imgWidth,
    imgHeight,
    imgTitle,
    imageOrig,
    image_styles,
    body
  } = node;
  const classes = useStyles(props);

  const open = <span className='expand-css'>Show More <ExpandMoreIcon/></span>
  const close = <span className='expand-css'>Show Less <ExpandLessIcon/></span>

  let getImageStyle = pickImageStyle({
      imgAlt,
      imgTitle,
      imgWidth,
      imgHeight,
      imageOrig,
      image_styles,
      title: 'Media'
    },
    'max_510_height', process.env.NEXT_PUBLIC_FRONT_URL + '/assets/placeholder.jpg');
  ({imgAlt, imgTitle, imgWidth, imgHeight, imageOrig} = getImageStyle);

  return (
    <Container>
      <Box py={4} className={classes.teamHeader}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={3}>
            <Image style={{ objectFit: "cover", width: '100%', height: 'auto' }} width="310" height="350" sizes='50vw' className={classes.imgStyles} src={imageOrig} alt={imgAlt}
                 title={imgTitle}/>
          </Grid>
          <Grid item xs={12} md={9}>
            <Typography className={classes.titleStyles}
                        component="h3">
              <strong>
                {info?.first}
              </strong>
            </Typography>
            {info?.second &&
            <Typography className={classes.subtitleStyles}
                        component="h4">
              {info?.second}
            </Typography>
            }
            {contact?.length > 0 && contact?.map((c, index) => (
              <>
                {c?.second?.length > 0 &&
                <Box my={1} display='flex' alignItems='center' key={`mail-${index}`}>
                  <MailOutlineIcon color='primary'/>
                  <Link href={`mailto:${c?.second}`} underline='none'
                        className={classes.linkStyles}>
                    {c?.second}
                  </Link>
                </Box>
                }
                {c?.first?.length > 0 &&
                <Box my={1} color="info.main" key={`phone-${index}`}>
                  <PhoneIcon/><Link href={c.first}> {c.first}</Link>
                </Box>
                }
              </>
            ))}
            {body?.length > 0 &&
            <>
              <hr style={{width: '40%', margin: '1rem 0 0 0'}}/>
              <Typography className={classes.bodyStyles} component="div"
                          >
                            <ShowMoreText
                              lines={4}
                              more={open}
                              less={close}
                              className="content-css"
                              anchorClass="expandAnchor"
                              expanded={false}
                              truncatedEndingComponent={"... "}
                            >
                              <div dangerouslySetInnerHTML={{__html: body}} />
                            </ShowMoreText>
              </Typography>
            </>
            }
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};
